export default __webpack_public_path__ + "static/media/admin-image.bdacc3b4.svg";